module.exports = __webpack_public_path__ + "static/media/pic5.fd29e920.jpg";